import { useEffect } from 'react';

import { useAuth } from '@/auth';

const rootEnv = window.LUCID_SPA_CONFIG;

export const APPCUES_ID = rootEnv?.APPCUES_ID || '';
export const DEPLOYMENT_ENV = rootEnv?.DEPLOYMENT_ENV || '';
export const APP_VERSION = rootEnv?.APP_VERSION || '';
export const IS_TEST = import.meta.env.MODE === 'test';

const isDevOrTest = import.meta.env.DEV || IS_TEST;

declare global {
  interface Window {
    Appcues: any;
  }
}
declare global {
  interface Window {
    AppcuesSettings: any;
  }
}

export function Appcues() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isDevOrTest || !APPCUES_ID || !isAuthenticated) {
      return;
    }

    const identifyUser = () => {
      if (window.Appcues) {
        window.Appcues.identify(user.sub || user.email, {
          email: user?.email,
          displayName: user?.name || user?.nickname,
        });
      }
    };

    window.AppcuesSettings = {
      enableURLDetection: true,
    };

    if (!window.Appcues) {
      const script = document.createElement('script');
      script.src = `//fast.appcues.com/${APPCUES_ID}.js`;
      script.async = true;
      script.onload = identifyUser;
      document.body.appendChild(script);
    } else if (window.Appcues) {
      identifyUser();
    }
  }, [isAuthenticated, user]);
  return null;
}
